var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlarmMagnet = function SvgAlarmMagnet(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg869",
    width: 35.153,
    height: 35.153,
    viewBox: "0 0 35.153 35.153",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path982",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.983.703V34.45L7.734 32.34V4.219z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2001",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 3.515h6.42v28.826H21"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "path2409",
    cx: 16.859,
    cy: 17.858,
    fill: "currentColor",
    rx: 0.703,
    ry: 1.141
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlarmMagnet);
export default ForwardRef;